import useKeyboardShortcut, { keyValuesByKey } from "@secureo/common/hooks/useKeyboardShortcut"
import getLastArrayElement from "@secureo/common/utils/getLastArrayElement"

import { SpecialMatrixType } from "reducers/lockingSystemReducer"

const hasFocussedBodyElement = () => {
	return document.activeElement === document.body
}

const useLockingSystemKeyboardShortcuts = (
	{
		addDefaultLock,
		duplicateLock,
		addDefaultKey,
		duplicateKey,
		setSpecialMatrix,
	}: {
		addDefaultLock: () => void
		duplicateLock: (uuid: string) => void
		addDefaultKey: () => void
		duplicateKey: (uuid: string) => void
		setSpecialMatrix: (specialMatrixType: SpecialMatrixType) => void
	},
	lockingComponentsUuids: string[],
	keyComponentsUuids: string[],
	isEnabled: boolean,
) => {
	const lastLockingComponentUuid = getLastArrayElement(lockingComponentsUuids)
	const lastKeyComponentUuid = getLastArrayElement(keyComponentsUuids)

	// Locking components
	useKeyboardShortcut(keyValuesByKey["SHIFT +"], () => {
		if (isEnabled && hasFocussedBodyElement() && addDefaultLock) {
			addDefaultLock()
		}
	})

	useKeyboardShortcut(keyValuesByKey["SHIFT D"], () => {
		if (isEnabled && hasFocussedBodyElement() && !!lastLockingComponentUuid && duplicateLock) {
			duplicateLock(lastLockingComponentUuid)
		}
	})

	// Key components
	useKeyboardShortcut(keyValuesByKey["SHIFT ALT/OPTION +"], () => {
		if (isEnabled && hasFocussedBodyElement() && addDefaultKey) {
			addDefaultKey()
		}
	})

	useKeyboardShortcut(keyValuesByKey["SHIFT ALT/OPTION D"], () => {
		if (isEnabled && hasFocussedBodyElement() && !!lastLockingComponentUuid && duplicateKey) {
			duplicateKey(lastKeyComponentUuid)
		}
	})

	// Matrix
	useKeyboardShortcut(keyValuesByKey["SHIFT ALT/OPTION E"], () => {
		if (isEnabled && hasFocussedBodyElement() && !!lastLockingComponentUuid && duplicateKey) {
			setSpecialMatrix("single")
		}
	})

	useKeyboardShortcut(keyValuesByKey["SHIFT ALT/OPTION G"], () => {
		if (isEnabled && hasFocussedBodyElement() && !!lastLockingComponentUuid && duplicateKey) {
			setSpecialMatrix("simultaneous")
		}
	})
}

export default useLockingSystemKeyboardShortcuts
